import React, { useState, useEffect, useRef } from "react";
import {
  MenuItem,
  Select,
  TextField,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";

const useStyles2 = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 8,
    padding: theme.spacing(2),
  },

  header: {
    position: "relative", // 👈 IMPORTANT
    paddingRight: theme.spacing(5), // space for close icon
  },

  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },

  content: {
    marginTop: theme.spacing(2),
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 16,
    marginTop: theme.spacing(3),
  },
}));

export default function MatrixModel({
  open,
  onClose,
  type,
  questions,
  setQuestions,
  matrixState,
}) {
  const classes = useStyles2();
  const firstInputRef = useRef(null);
const [tempQuestions,setTempQuestions] = useState(questions)

  const list =
    tempQuestions.find((q) => Number(q.id) === Number(matrixState?.rowId))
      ?.correct_answers || [];

  const handleChange = (index, field, value) => {
    setTempQuestions((prev) =>
      prev.map((question) => {
        if (Number(question.id) !== Number(matrixState.rowId)) return question;

        const updatedCorrectAnswers = question.correct_answers.map(
          (item, i) => {
            if (type === "match" || field === 'option' ) {
              return i === index
                ? { ...item, [field]: value.slice(0, 1).toUpperCase() }
                : item;
            } else {
              return i === index
                ? {
                    ...item,
                    [field]: value
                      .split(",")
                      .map((item) => item.trim().split("")) // Split each item into characters
                      .flat() // Flatten the array
                      .join(" , ")
                      .toUpperCase(),
                  }
                : item;
            }
          }
        );

        return {
          ...question,
          correct_answers: updatedCorrectAnswers,
        };
      })
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableAutoFocus={false}
      disableEnforceFocus={false}
      disableRestoreFocus={false}
      classes={{ paper: classes.dialogPaper }}
    >
      {/* HEADER */}
      <DialogTitle className={classes.header}>
        <Typography variant="h6" style={{ textTransform: "capitalize" }}>
          {type} options & answers
        </Typography>

        {/* CLOSE ICON */}
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent>
        <Box style={{ display: "flex", gap: 10, marginTop: 10,justifyContent:'center' }}>
          {/* OPTIONS */}
          <Box style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {list.map((ca, index) => (
              <TextField
                inputRef={index === 0 ? firstInputRef : null} // पहले input को reference दें
                variant="outlined"
                disabled
                key={`option-${index}`}
                value={ca.option || ""}
                placeholder="Option"
                autoFocus={index === 0} // पहले input पर autoFocus
                size="small"
                onChange={(e) => handleChange(index, "option", e.target.value)}
              />
            ))}
          </Box>

          {/* ANSWERS */}
          <Box style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {list.map((ca, index) => (
              <TextField
                variant="outlined"
                disabled
                key={`answer-${index}`}
                value={ca.answer || ""}
                placeholder="Answer"
                size="small"
                onChange={(e) => handleChange(index, "answer", e.target.value)}
              />
            ))}
          </Box>
        </Box>
      </DialogContent>
      <div style={{ display: "flex",justifyContent:'end',marginTop:20 }}>
        <Button
          variant="contained"
          color="primary"
          style={{ width: 100, float: "right" }}
          onClick={()=>{setQuestions(tempQuestions)
            onClose()
          }}
        >
          submit
        </Button>
      </div>
    </Dialog>
  );
}
